import * as React from "react";

interface IProps {
  className?: string;
  onClick?: () => void;
}

export const SLIcon = (size1: any, size2: any, size3?: any) => {
  const srcSet = size3 ? `${size2} 2x,${size3} 3x` : `${size2} 2x`;
  const Icon: React.SFC<IProps> = ({ className, onClick }) => (
    <img src={size1} srcSet={srcSet} className={className} onClick={onClick} />
  );

  return Icon;
};



// WEBPACK FOOTER //
// ./src/components/Icons/SLIcon.tsx